export default {
  goBack: 'Back to',
  subscriptionsPage: 'your subscriptions',
};
